// extracted by mini-css-extract-plugin
export default {"container":"SocialMedia_container__SJZ8E","link":"SocialMedia_link__7oDRg","icon":"SocialMedia_icon__R+l9T"};